import Accordion from '@ui/accordion/Accordion';
import AccordionItem from '@ui/accordion/AccordionItem';
import ModalDialog from '@stone/components/modal/ModalDialog';
// import analytics from '@utils/analytics';
import api from '@utils/api';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import BodyMeasurements from './BodyMeasurements';
import HowToMeasure from './HowToMeasure';
import SizeGuideButton from './SizeGuideButton';
import useModelMeasures from '@stone/hooks/useModelMeasures';
import useMediaQueries from '@stone/hooks/useMediaQueries';
import cookie from 'react-cookies';
import customEventBus from '@common/scripts/libs/eventBus';
import analytics from '@stone/utils/analytics';
const measmerizeconfig = {
    url: 'https://client.measmerize.com/script.js',
    brandid: window.measmerizeBrandIdWeb,
};
const SizeGuide = (props) => {
    const { t } = useTranslation();
    const [sizeChart, setSizeChart] = useState();
    const [measmerizeavailable, setMeasmerizeavailable] = useState(!!window.measmerizeBrandIdWeb);
    const [selectedTab, setSelectedTab] = useState(0);
    const measmerizeSuggestedSize = useRef();
    const measmerizeSelectedSize = useRef();
    const measmerizeReady = useRef(false);
    const waitingForMeasmerize = useRef();
    const { measureConverter } = useModelMeasures();
    const { isMobile } = useMediaQueries();
    const scriptWrapId = 'measmerize-script-wrap';
    useEffect(() => {
        embedMeasmerize(props.pid);
        // embedMeasmerize(props.master);
        return () => {
            removeMeasmerizeListeners();
        };
    }, [props.pid, measmerizeavailable]);
    const firstRender = useRef('');
    useEffect(() => {
        if (props.open && firstRender.current != props.pid) {
            firstRender.current = props.pid;
            api.getSizeChart(props.pid).then((data) => setSizeChart(data));
        }
    }, [props.pid, props.open]);
    useEffect(() => {
        props.open ? document.documentElement.classList.add('sizeguide-enabled') : document.documentElement.classList.remove('sizeguide-enabled');
        return () => {
            document.documentElement.classList.remove('sizeguide-enabled');
        };
    }, [props.open]);
    const createScriptWrap = () => {
        const scriptWrap = document.createElement('div');
        scriptWrap.setAttribute('id', scriptWrapId);
        document.body.appendChild(scriptWrap);
        return scriptWrap;
    };
    const addMeasmerizeListeners = (script) => {
        script.addEventListener('measmerize.widget.ready', onMeasmerizeReady);
        script.addEventListener('measmerize.widget.unavailable', onMeasmerizeUnavailable);
        script.addEventListener('measmerize.widget.recommend', onMeasmerizeRecommend);
        script.addEventListener('measmerize.widget.select', onMeasmerizeSelect);
        script.addEventListener('measmerize.modal.close', onSizeGuideClose);
    };
    const embedMeasmerize = (pid) => {
        if (pid) {
            const scriptID = 'measmerize-script';
            const previousScript = document.getElementById(scriptID);
            if (pid && measmerizeavailable) {
                if (previousScript) {
                    window.measmerize.script.productCode = props.pid;
                    measmerizeReady.current = true;
                    addMeasmerizeListeners(previousScript);
                    return;
                }
                const script = document.createElement('script');
                const scriptWrap = document.getElementById(scriptWrapId) || createScriptWrap();
                script.id = scriptID;
                script.src = 'https://client.measmerize.com/script.js';
                script.async = true;
                script.setAttribute('data-brand-code', window.measmerizeBrandIdWeb);
                script.setAttribute('data-product-code', pid);
                script.setAttribute('data-lang-code', window.language);
                script.setAttribute('data-country-code', window.country);
                addMeasmerizeListeners(script);
                scriptWrap === null || scriptWrap === void 0 ? void 0 : scriptWrap.appendChild(script);
            }
        }
    };
    const removeMeasmerizeListeners = () => {
        const script = document.getElementById('measmerize-script');
        if (script) {
            measmerizeReady.current = false;
            script.removeEventListener('measmerize.widget.ready', onMeasmerizeReady);
            script.removeEventListener('measmerize.widget.unavailable', onMeasmerizeUnavailable);
            script.removeEventListener('measmerize.widget.recommend', onMeasmerizeRecommend);
            script.removeEventListener('measmerize.widget.select', onMeasmerizeSelect);
            script.removeEventListener('measmerize.modal.close', onSizeGuideClose);
        }
        props.onSizeSuggestion && props.onSizeSuggestion('');
    };
    const onMeasmerizeReady = (ev) => {
        measmerizeReady.current = true;
        toggleMeasmerizeAnalytics();
        customEventBus.on('cookieConsent:clicked', toggleMeasmerizeAnalytics);
        window.addEventListener('OneTrust:changed', toggleMeasmerizeAnalytics);
        if (waitingForMeasmerize.current) {
            window.measmerize.modal.mount();
            waitingForMeasmerize.current = false;
        }
        return true;
    };
    const onMeasmerizeUnavailable = () => {
        setMeasmerizeavailable(false);
    };
    const onSizeGuideClose = () => {
        const size = measmerizeSelectedSize.current || measmerizeSuggestedSize.current;
        props.onSizeguideSelection && props.onSizeguideSelection(size);
        analytics.findMySize(props.pid, 'select', size);
        props.setSizeguideOpen(false);
    };
    const onMeasmerizeRecommend = (event) => {
        var _a;
        measmerizeSuggestedSize.current = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.size;
        props.onSizeSuggestion(measmerizeSuggestedSize.current);
    };
    const onMeasmerizeSelect = (event) => {
        var _a;
        measmerizeSelectedSize.current = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.size;
    };
    const toggleMeasmerizeAnalytics = () => {
        let thirdParyAccepted = false;
        if (window.cookiePolicy === 'OneTrust' && cookie.load('OptanonAlertBoxClosed')) {
            // OneTrust
            const oneTrustChoices = cookie.load('OneTrustChoices');
            thirdParyAccepted = oneTrustChoices && oneTrustChoices.meTracking;
        }
        else if (cookie.load('TC_PRIVACY_CENTER')) {
            //Legacy Cookie System
            thirdParyAccepted = cookie.load('TC_PRIVACY_CENTER').includes('2');
        }
        if (thirdParyAccepted) {
            window.measmerize.tracking.enableAnalytics();
        }
        else {
            window.measmerize.tracking.disableAnalytics();
        }
    };
    const tabsLayout = () => (React.createElement(Tabs, { className: "tabs tabs--padding sizechart-tabs", forceRenderTabPanel: true, onSelect: (i) => setSelectedTab(i) },
        React.createElement(TabList, { className: "react-tabs__tab-list" },
            measmerizeavailable && sizeChart.mannequinGender != 'kid' && React.createElement(Tab, null, t('sizeguide.findmysize')),
            React.createElement(Tab, null, (props === null || props === void 0 ? void 0 : props.hideBodyMeasurements) ? t('sizeguide.itemmeasurements') : t('sizeguide.bodymeasurements')),
            sizeChart.mannequinGender && sizeChart.mannequinGender != 'none' && React.createElement(Tab, null, t('sizeguide.howtomeasure.title'))),
        selectedTab !== 0 && modelSizesLayout(),
        React.createElement("div", null,
            measmerizeavailable && sizeChart.mannequinGender != 'kid' && (React.createElement(TabPanel, null,
                React.createElement("div", { id: "measmerize-modal" }))),
            React.createElement(TabPanel, null,
                React.createElement(BodyMeasurements, { sizeChart: sizeChart, isSelected: selectedTab === 1 })),
            sizeChart.mannequinGender && sizeChart.mannequinGender != 'none' && (React.createElement(TabPanel, null,
                React.createElement(HowToMeasure, { contactformurl: props === null || props === void 0 ? void 0 : props.contactformurl, mannequinGender: sizeChart.mannequinGender.toLocaleLowerCase() }))))));
    const modelSizeItem = (title, desc) => {
        if (!desc) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement("p", null,
            React.createElement("span", { className: "sizeguide-modelsizes-title font__title" }, title),
            React.createElement("span", { className: "sizeguide-modelsizes-desc" }, desc)));
    };
    const modelSizes = () => {
        var _a, _b, _c;
        return (React.createElement("div", { className: "sizeguide-modelsizes" },
            React.createElement("img", { src: (_b = (_a = props.imgs) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.find((el) => el.includes('_R')), alt: (_c = props.imgs) === null || _c === void 0 ? void 0 : _c.alt }),
            React.createElement("div", { className: "sizeguide-modelsizes-info" },
                React.createElement("h3", { className: "sizeguide-modelsizes-head font-light--uc" }, t('label.modelmeasures.title')),
                React.createElement("div", { className: "sizeguide-modelsizes-table" },
                    modelSizeItem(t('label.modelmeasures.size'), props.modelMeasures.modelSize),
                    modelSizeItem(t('label.modelmeasures.height'), measureConverter(props.modelMeasures.modelHeight)),
                    modelSizeItem(t('label.modelmeasures.hips'), measureConverter(props.modelMeasures.modelHips)),
                    modelSizeItem(t('label.modelmeasures.fit'), props.modelMeasures.sizeAndFit),
                    modelSizeItem(t('label.modelmeasures.chest'), measureConverter(props.modelMeasures.modelChest)),
                    modelSizeItem(t('label.modelmeasures.waist'), measureConverter(props.modelMeasures.modelWaist))))));
    };
    const modelSizesLayout = () => {
        return (props.modelMeasures &&
            props.modelMeasures.modelHeight &&
            props.modelMeasures.modelSize &&
            (isMobile ? (React.createElement(Accordion, null,
                React.createElement(AccordionItem, { title: React.createElement("div", { className: "sizeguide-modelsizes-table" },
                        modelSizeItem(t('label.modelmeasures.size'), props.modelMeasures.modelSize),
                        props.modelMeasures.sizeAndFit && modelSizeItem(t('label.modelmeasures.fit'), props.modelMeasures.sizeAndFit)), isTitleMarkup: true, accordionId: "body", itemClass: "sizeguide-modelsizes-accordion-item" }, modelSizes()))) : (modelSizes())));
    };
    return (React.createElement(React.Fragment, null,
        !(props === null || props === void 0 ? void 0 : props.onlyModal) && (React.createElement(React.Fragment, null,
            window.measmerizeBrandCode && (React.createElement("div", { className: "recommended" },
                React.createElement("span", { id: "measmerize-result-wrap", className: "recommended__label" }))),
            React.createElement(SizeGuideButton, { pid: props.pid, onSizeGuideOpen: () => props.setSizeguideOpen(true), withAria: true }))),
        sizeChart && (React.createElement(ModalDialog, { isOpen: props.open, onRequestClose: () => {
                // analytics.sizeGuideOverlay(props.pid, 'close');
                onSizeGuideClose();
            }, onAfterClose: () => {
                var _a, _b;
                setSelectedTab(0);
                (_b = (_a = window.measmerize) === null || _a === void 0 ? void 0 : _a.modal) === null || _b === void 0 ? void 0 : _b.unMount();
            }, onAfterOpen: () => {
                if (measmerizeReady.current) {
                    window.measmerize.modal.mount();
                }
                else {
                    waitingForMeasmerize.current = true;
                }
            }, className: "size-modal measmerizemodal", fullHeight: true, fullWidth: true }, tabsLayout()))));
};
export default SizeGuide;
